import { MODAL_LEAVE_FEEDBACK } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'

export type FeedbackSource = 'general' | 'export' | 'wireframe'

export const openLeaveFeedbackModal = (source: FeedbackSource) => {
  // @ts-expect-error Legacy openModal infers modalProps from its null default.
  return openModal(MODAL_LEAVE_FEEDBACK, { source })
}
